var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4944 9.47158C13.7851 9.76227 13.7851 10.2323 13.4944 10.5199L7.55693 16.4605C7.26624 16.7512 6.79618 16.7512 6.50859 16.4605C6.22099 16.1698 6.2179 15.6998 6.50859 15.4122L11.9204 10.0004L6.50549 4.58551C6.2148 4.29482 6.2148 3.82477 6.50549 3.53717C6.79618 3.24957 7.26624 3.24648 7.55383 3.53717L13.4944 9.47158Z",
    fill: "#526077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.51731d23.svg";
export { ForwardRef as ReactComponent };